<template>
  <div class="in-app-ads">
    
    <v-dialog max-width="600" v-model="createAdDialog">
      <v-card class="pa-10">
        <v-form @submit.prevent="create">
          <v-row align-content="end">
            <v-col v-if="false">
              <v-text-field
                v-model="image_url"
                label="Image Url"
                hint="Image should be exactly 1200x628 pixels."
              />
            </v-col>
            <v-col cols="12">
              <v-file-input
                outlined
                ref="fileupload"
                label="Upload Image"
                hint="Image should be exactly 1200x628 pixels."
                @change="onFileChange"
                :loading="uploadLoading"
              />
            </v-col>

            <v-col cols="12" v-if="uploadedFile">
              <v-responsive>
                <v-img :src="uploadedFile.fileUrl" />
              </v-responsive>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                v-model="redirect_url"
                label="Redirect Url"
                hint="Make sure to include https://"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                :disabled="!canSubmit"
                block
                depressed
                type="submit">
                Create
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row justify="end">
      <v-col cols="4">
        <v-btn block depressed color="primary" @click="createAdDialog = true">
          Create Ad
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Active</th>
                <th class="text-left">
                  Image
                </th>
                <th class="text-left">
                  Redirect
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in inAppAds"
                :key="item.id"
              >
                <td><v-simple-checkbox :value="item.active" @click.prevent="update(item)"></v-simple-checkbox></td>
                <td v-if="!item.file_id"><v-responsive><img class="pt-3 pb-1" style="max-width: 100px" :src="item.image_url" /></v-responsive></td>
                <td v-else><v-responsive><img class="pt-3 pb-1" style="max-width: 100px" :src="item.file_upload.fileUrl" /></v-responsive></td>
                <td><a :href="item.redirect_url">{{ item.redirect_url }}</a></td>
                <td><v-btn icon depressed @click.prevent="remove(item.id)"><v-icon>mdi_delete</v-icon></v-btn></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'InAppAdForm',
  data() {
    return {
      image_url: null,
      redirect_url: null,
      file: null,
      createAdDialog: false,
      uploadedFile: null,
      formData: null,
      uploadLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      inAppAds: 'in-app-ad/list',
    }),
    inAppAdsLoading() {
      return this.$store.state['in-app-ad'].isFindPending
    },
    canSubmit() {
      return this.file !== null && this.redirect_url !== null
    }
  },
  methods: {
    async onFileChange(file) {
      this.file = file
      await this.uploadImage()
    },
    async uploadImage() {
      if (this.file) {
        this.formData = new FormData()
        this.formData.append('file', this.file)
        this.formData.append('eccoType', 'in-app-ad')
        this.uploadLoading = true
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/file-upload`, this.formData, {
          headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${this.$store.state.auth.accessToken}` }
        })
        console.log(response)
        this.uploadedFile = response.data
        this.uploadLoading = false
      }
    },
    async create() {
      await this.$store.dispatch('in-app-ad/create', {
        file_id: this.uploadedFile.id,
        redirect_url: this.redirect_url,
        active: false,
        enableAt: Date.now()
      })

      this.uploadedFile = null
      this.redirect_url = null
      this.file = null
      this.createAdDialog = false
      this.formData = null
      this.$refs.fileupload.value = null;
      await this.fetchInAppAds()
    },
    async update(item) {
      await this.$store.dispatch('in-app-ad/patch', [item.id, {
        active: !item.active,
      }, {}])
    },
    async remove(id) {
      await this.$store.dispatch('in-app-ad/remove', [id])
    },
    async fetchInAppAds() {
      await this.$store.dispatch('in-app-ad/find', {
        query: {
          $limit: 50,
        }
      })
    },
  },
  async mounted() {
    await this.fetchInAppAds()
  }
}
</script>

<style lang="sass">
</style>